import { HelpMeChoose, HomeHeroV2, PartExchangeSection, ValuePropositions, WhyCinch, UspSlide } from "../components";
export const storyblokComponents = {
    HomeHeroV2: HomeHeroV2,
    HelpMeChooseSection: HelpMeChoose,
    WhyCinchSection: WhyCinch,
    PartExSection: PartExchangeSection,
    ValuePropsCard: ValuePropositions,
    HomeUspSlide: UspSlide
};
